import React from "react";
import { motion } from "framer-motion";
import { Clock, Eye, LayoutList, PackageCheck, ShieldCheck, Shuffle, BoxIcon } from "lucide-react";
import { benefits } from "../data/benefits";
const icons: BoxIcon[] = [Clock, PackageCheck, LayoutList, Eye, Shuffle, ShieldCheck];
export function Benefits() {
  return <section className="py-24 px-4 bg-section border-y border-line" data-id="element-17" data-mp="3vrifjk89hkby">
      <div className="max-w-6xl mx-auto" data-id="element-18" data-mp="3qrnmpb4xeko9">
        <div className="text-center max-w-2xl mx-auto mb-14" data-id="element-19" data-mp="3qsfaw0w71g4i">
          <p className="text-gold font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-20" data-mp="3mqai14dkknix">
            Ready-to-use training material
          </p>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white" data-id="element-21" data-mp="3hrhf25vwsex0">
            100% visual. Built for real boxing classes.
          </h2>
        </div>
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-22" data-mp="1fzulbwkmu5wu">
          {benefits.map((benefit, index) => {
          const Icon = icons[index];
          return <motion.li key={benefit.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="bg-card border border-line rounded-2xl p-7 shadow-[0_18px_40px_-28px_rgba(0,0,0,0.9)]" data-id="element-23" data-mp="1ayf2mb5xgbhm" data-mpi={index}>
                <div className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center text-gold mb-5" data-id="element-24" data-mp="liqp1vkmy1dl">
                  <Icon size={20} aria-hidden="true" data-id="element-25" data-mp="qfz8s0lfmdgy" />
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-2" data-id="element-26" data-mp="bqusioy76jbh">{benefit.title}</h3>
                <p className="text-sm text-mist leading-relaxed" data-id="element-27" data-mp="gpxlvc4tf13m">{benefit.text}</p>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}